import React, { useEffect, useMemo, useRef, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Row,
	Overlay,
	Popover,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchAllOrgsData,
	selectAllOrgs,
} from "../../redux/actions/getAllOrgsAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";

import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";

const AddCertificate = ({
	getUserCv,
	userDataId,
	showCertificate,
	handleCloseCertification,
}) => {
	console.log("userDataId", userDataId);

	const targetRef = useRef(null);

	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();

	const [newEducation, setNewEducation] = useState("");
	const [showTooltip, setShowTooltip] = useState(false);
	const [certificateName, setCertificateName] = useState("");
	const [recognition, setRecognition] = useState("");
	const [credentialId, setCredentialId] = useState("");
	const [Description, setDescription] = useState("");
	const [IssueDate, setIssueDate] = useState("");
	const [ExpiredDate, setExpiredDate] = useState("");
	const [InsName, setInsName] = useState("");
	const [display, setDisplay] = useState(false);

	const [OrgName, setOrgName] = useState("");
	const [OrganizationName, setOrganizationName] = useState("");
	console.log("OrganizationName", OrganizationName);

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);

	// .................................................................
	const handleFieldChange = (setter, value, fieldName) => {
		setter(value);

		// Ensure values are strings (avoid .trim() errors)
		const updatedCertificateName = fieldName === "certificateName" ? String(value || "") : String(certificateName || "");
		const updatedRecognition = fieldName === "recognition" ? String(value || "") : String(recognition || "");
		const updatedCredentialId = fieldName === "credentialId" ? String(value || "") : String(credentialId || "");
		const updatedCitySearch = fieldName === "citySearch" ? String(value || "") : String(citySearch || "");
		const updatedIssueDate = fieldName === "issueDate" ? String(value || "") : String(IssueDate || "");
		const updatedExpiredDate = fieldName === "expiredDate" ? String(value || "") : String(ExpiredDate || "");
		const updatedIsChecked = fieldName === "isChecked" ? value : isChecked;

		// Required fields (Expiration Date is required only if isChecked is true)
		const allFieldsFilled =
			updatedCertificateName.trim() !== "" &&
			updatedRecognition.trim() !== "" &&
			updatedCredentialId.trim() !== "" &&
			updatedCitySearch.trim() !== "" &&
			updatedIssueDate.trim() !== "" &&
			(!updatedIsChecked || updatedExpiredDate.trim() !== ""); // If expiration is checked, it must be filled

		setFormChanged(allFieldsFilled);
	};
	// ...........................................................................	  

	console.log("userDataId===", userDataId);

	// const handleSubmit = async (e) => {
	// 	e.preventDefault();
	// 	setDisplay(true);
	// 	setIsSubmitting(true); // Disable the button during submission
	// 	const body = {
	// 		sessionId: sessionId,
	// 		userDataId: userDataId,
	// 		userType: userType,
	// 		instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

	// 		//orgID: getallorgsId === "" ? neworgId : getallorgsId,
	// 		orgID: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,

	// 		issuingOrgType: regdType
	// 			? (regdType === 1 ? 1 : regdType === 2 ? 2 : regdType === 3 ? 3 : regdType === 4 ? 4 : regdType === 5 ? 5
	// 				: null)
	// 			: 5,
	// 		name: certificateName,
	// 		recognition: recognition,
	// 		credentialId: credentialId,
	// 		description: Description,
	// 		cityId: citySearch,
	// 		issueDate: moment(IssueDate).format("YYYY-MM-DD"),
	// 		isExpirable: isChecked ? true : false,
	// 		expirationDate: !isChecked || !ExpiredDate ? null : moment(ExpiredDate).format("YYYY-MM-DD"),
	// 	};

	// 	console.log("body", body);
	// 	if (
	// 		certificateName === "" ||
	// 		(getallorgsId === "" && neworgId === "") ||
	// 		(orgType === "" && neworgType === "") ||
	// 		recognition === "" ||
	// 		credentialId === "" ||
	// 		// citySearch === '' ||
	// 		IssueDate === ""
	// 	) {
	// 		toast.error("Please fill all the required fields");
	// 		setIsSubmitting(false); // Re-enable the button if validation fails
	// 	} else {
	// 		try {
	// 			const res = await axios.post("/Resume/AddCertification", body);
	// 			toast.success(res.data.message);
	// 			resetForm();
	// 		} catch (error) {
	// 			if (error.response && error.response.status === 404) {
	// 				toast.error(error.response.data.message);
	// 			} else {
	// 				// toast.error(error.response?.data?.message );
	// 				toast.error(error.response?.data?.title);
	// 			}
	// 		} finally {
	// 			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
	// 		}
	// 	}
	// };


	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission

		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			orgID: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
			issuingOrgType: regdType
				? (regdType === 1 ? 1 : regdType === 2 ? 2 : regdType === 3 ? 3 : regdType === 4 ? 4 : regdType === 5 ? 5 : null)
				: 5,
			name: certificateName,
			recognition: recognition,
			credentialId: credentialId,
			description: Description,
			cityId: citySearch,
			issueDate: moment(IssueDate).format("YYYY-MM-DD"),
			isExpirable: isChecked ? true : false,
			expirationDate: !isChecked || !ExpiredDate ? null : moment(ExpiredDate).format("YYYY-MM-DD"),
		};

		console.log("body", body);

		// ✅ Validation with new condition added
		if (
			// certificateName === "" ||
			// (getallorgsId === "" && neworgId === "") ||
			// (orgType === "" && neworgType === "") ||
			// recognition === "" ||
			// credentialId === "" ||
			// IssueDate === "" ||
			// (IssueDate && !ExpiredDate) 
			certificateName.trim() === "" ||
			recognition.trim() === "" ||
			credentialId.trim() === "" ||
			citySearch === "" ||
			!IssueDate ||
			(getallorgsId === "" && neworgId === "") ||
			(orgType === "" && neworgType === "") ||
			(isChecked && !ExpiredDate)
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
			return;
		}

		try {
			const res = await axios.post("/Resume/AddCertification", body);
			toast.success(res.data.message);
			resetForm();
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title || "Something went wrong");
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled
		}
	};

	const resetForm = () => {
		handleCloseCertification();
		getUserCv();
		setOrgType("");
		setRecognition("");
		setGetAllOrgsId(null);
		setCitySearch("");
		setDescription("");
		setOrgType("");
		setCertificateName("");
		setInsName("");
		setOrgName("");
		setIsChecked("");
		setExpiredDate(null);
		setIssueDate(null);
		setCredentialId("");
		setDisplay(false);
		setFormChanged(false); // Disable the button after update
	};

	const handleCloseCertificationFn = () => {
		resetForm(); // Call resetForm when closing the modal
		handleCloseCertification();
	};
	//   Create New Certificate
	const [showCreateCertification, setShowCreateCertification] = useState(false);
	const handleOpenCreateCertification = () => setShowCreateCertification(true);
	const handleCloseCreateCertification = () =>
		setShowCreateCertification(false);

	const [isChecked, setIsChecked] = useState(false);

	// const handleCheckboxChange = () => {
	// 	setIsChecked(!isChecked);
	// };

	const dispatch = useDispatch();

	//   Get organization
	const [regdType, setRegdType] = useState("");
	const [getallorgsId, setGetAllOrgsId] = useState("");
	const [orgType, setOrgType] = useState("");
	const { getallorgsList, selectedgetallId } = useSelector(
		(state) => state.getallorgs
	);
	console.log("Org List==>", getallorgsList)
	const reversedAllOrgList = useMemo(() => {
		return [...getallorgsList].reverse(); // Create a new reversed copy
	}, [getallorgsList]);

	useEffect(() => {
		// dispatch(fetchOrgRegdInsData());

		dispatch(fetchAllOrgsData());
	}, [dispatch]);

	const handleOrganization = (selectedOption) => {
		if (selectedOption) {
			setGetAllOrgsId(selectedOption.value);
			setOrgType(selectedOption.label);
			setRegdType(selectedOption.tagId);
		} else {
			setGetAllOrgsId(null);

		}
	};

	// useEffect(() => {
	// 	if (OrganizationName) {
	// 		const newOrg = getallorgsList.find(org => org.label === OrganizationName);
	// 		if (newOrg) {
	// 			setGetAllOrgsId(newOrg.value);
	// 			setOrgName(newOrg.label);
	// 		}
	// 	}
	// }, [getallorgsList, OrganizationName]);

	const [orgCity, setOrgCity] = useState(null);
	const [citySearch, setCitySearch] = useState("");
	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);


	const handleCitySelect = (selectedOption) => {
		setCitySearch(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};


	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};
	const [fileName, setFileName] = useState(""); // State to store selected filename
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};

	const [neworgType, setneworgType] = useState("");
	const [neworgId, setneworgId] = useState("");
	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdGeneralOrg");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res", res);
			// setneworgType(res.data.responseData.value);
			setneworgId(res.data.responseData.id);
			toast.success(`${res.data.message} The newly created Organization is now available at the top of the dropdown. Please select it.`);
			setOrgCity("");
			setOrganizationName("")
			setOrgName("")
			dispatch(fetchAllOrgsData());

		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};

	return (
		<>
			<Modal
				show={showCertificate}
				onHide={handleCloseCertificationFn}
				centered
				size="lg"
			>
				<Modal.Header>
					<Modal.Title>Add certificate</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseCertificationFn}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						{/* Certificate Name */}
						<Col md={6} className="mb-2">
							<div className="post-form-group mb-0">
								<label
									htmlFor="certificateName "
									style={{ paddingBottom: "3px" }}
								>
									Certificate name <span style={{ color: "red" }}> *</span>
								</label>
								<input
									type="text"
									placeholder="Enter certificate name"
									value={certificateName}
									// onChange={(e) => {setCertificateName(e.target.value)}}
									// onChange={(e) =>handleFieldChange(setCertificateName, e.target.value)} // Track changes
									onChange={(e) => handleFieldChange(setCertificateName, e.target.value, "certificateName")}
								/>
								{display && !certificateName ? (
									<span className="error_msg_lbl">Add certification name </span>
								) : null}
							</div>
						</Col>

						{/* Organization */}
						<Col md={6} className="mb-2">

							<Form.Group controlId="addorganization">
								<Form.Group controlId="organization">
									<Form.Label className="class-type">
										Organization
										<span style={{ color: "red" }}> *</span>
									</Form.Label>
									{OrgName !== "" ? (
										<div>
											<input
												type="text"
												value={OrgName}
												placeholder="Enter Org name"
												className="mb-2 form-control Dark-Input-from-group"
												disabled
											/>
										</div>
									) : (
										<div className="post-form-group">
											<ReactSelect
												options={reversedAllOrgList}
												// onChange={handleOrganization}
												onChange={(selectedOption) => handleFieldChange(handleOrganization, selectedOption)}
												// onChange={(option) => {
												// 	handleFieldChange(setGetAllOrgsId, option ? option.value : "", "getallorgsId");
												// 	setOrgType(option ? option.tagId : "");
												// 	setRegdType(option ? option.tagId : "");
												// }}
												value={
													reversedAllOrgList.find((
														(option) => {
															if (InsName !== "" && InsName !== null) {
																return option.value === InsName;
															} else {
																return option.value === getallorgsList && option.tagId === regdType;
															}
														}
													))
												}
												//value={getallorgsList.find((option) => String(option.value) === String(getallorgsId)) || null}
												getOptionValue={(option) => `${option.value}-${option.tagId}`}

												// value={
												// 	getallorgsList.find(
												// 		(option) => option.value === getallorgsId && option.tagId === regdType
												// 	) || null
												// }
												// getOptionValue={(option) => `${option.value}-${option.tagId}`}
												formatOptionLabel={(option) => (
													<div style={{ fontWeight: option.tagId === 1 || option.tagId === 2 ? "bold" : "normal" }}>
														{option.label} <span>({option.tagId === 1 ? "Insitution" : option.tagId === 2 ? "Company" : option.tagId === 3 ? "UnredgCompany" : option.tagId === 4 ? "UnredgInstitution" : option.tagId === 5 ? "UnRegdGeneralOrg" : ""})</span>
													</div>
												)}

												placeholder="Select Organization"
												classNamePrefix="react-select"
												className="form-control Dark-Input-from-group"
												styles={customStyles}
												isClearable
											/>
										</div>
									)}
								</Form.Group>
								<a
									href="#"
									ref={targetRef}
									onClick={(e) => {
										e.preventDefault();
										toggleTooltip();
									}}
									className="createModal"
								// isDisabled={!selectedIndustryId} // Disable until industry is selected
								>
									Create new
								</a>
								<Overlay
									target={targetRef.current}
									show={showTooltip}
									placement="right"
									rootClose
									container={document.querySelector(".modal")}
									onHide={() => setShowTooltip(false)} // Close when clicking outside
								>
									<Popover id="popover-basic" className="overlay-popover-modal">
										<Popover.Header as="h3" className="Dark-Body-Card-group">Create organization</Popover.Header>
										<Popover.Body className="Dark-Body-Card-group">
											<Form>
												<div>
													<label className="mb-1 Text-mb-Create">Org name</label>
													<input
														type="text"
														value={OrganizationName}
														onChange={(e) => {
															setOrganizationName(e.target.value)
															setOrgName(e.target.value);
														}}
														// onChange={(e) => {
														// 	setOrganizationName(e.target.value);
														// 	setOrgName(e.target.value);
														// 	setGetAllOrgsId(e.target.value); // Ensure getallorgsId is updated
														// 	handleFieldChange(setGetAllOrgsId, e.target.value, "getallorgsId"); // Trigger validation
														// }}
														placeholder="Enter Org name"
														className="mb-2 form-control Dark-Input-from-group"
													/>
												</div>

												<div>
													<label className="mb-1 Text-mb-Create">City</label>
													<ReactSelect
														options={cityNameOption}
														onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
														onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
														placeholder="Search & Select City"
														classNamePrefix="react-select"
														className="form-control Dark-Input-from-group"
														styles={customStyles}
														isClearable
													/>
												</div>
												<div className=" mt-2 mb-2 Text-mb-Create">
													<label className="mb-1">Org logo</label>
													<input
														type="file"
														id="lastName"
														className="form-control Dark-Body-Card-group"
														placeholder=""
														onChange={handleFileChange}

													/>

												</div>
												<div className="d-flex justify-content-end">
													<Button
														variant="primary"
														size="sm"
														onClick={() => {
															handleSaveInstitution()
															setShowTooltip(false)
														}
														}

														className="me-2"
													>
														Save
													</Button>
													<Button
														variant="secondary"
														size="sm"
														onClick={() => setShowTooltip(false)}
													>
														Cancel
													</Button>
												</div>
											</Form>
										</Popover.Body>
									</Popover>
								</Overlay>
							</Form.Group>
						</Col>

						{/* Recognition */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="recognition">
									Recognition <span style={{ color: "red" }}> *</span>
								</label>
								<input
									type="text"
									placeholder="Enter recognition"
									value={recognition}
									// onChange={(e) => {setRecognition(e.target.value)}}
									// onChange={(e) =>handleFieldChange(setRecognition, e.target.value)} 
									onChange={(e) => handleFieldChange(setRecognition, e.target.value, "recognition")}
								/>
								{display && !recognition ? (
									<span className="error_msg_lbl">Add recognition </span>
								) : null}
							</div>
						</Col>

						{/* Credential ID */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="credentialId">
									Credential id <span style={{ color: "red" }}> *</span>
								</label>
								<input
									type="text"
									placeholder="Enter credential ID"
									value={credentialId}
									// onChange={(e) => {setCredentialId(e.target.value) }}
									// onChange={(e) =>handleFieldChange(setCredentialId, e.target.value)} // Track changes
									onChange={(e) => handleFieldChange(setCredentialId, e.target.value, "credentialId")}
								/>
								{display && !credentialId ? (
									<span className="error_msg_lbl">Add credential id </span>
								) : null}
							</div>
						</Col>

						{/* City */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="city">
								<Form.Label className="class-type">
									City <span style={{ color: "red" }}> *</span>
									{/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
								</Form.Label>
								<div className="post-form-group">
									<ReactSelect
										options={cityNameOption}
										onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
										// onChange={handleCitySelect} // Select hone ke baad clear ho jaye
										onChange={(option) => handleFieldChange(setCitySearch, option ? option.value : "", "citySearch")}
										placeholder="Search & Select City"
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										styles={customStyles}
										isClearable
									/>
									{display && !citySearch ? (
										<span className="error_msg_lbl">Search & select city </span>
									) : null}
								</div>
							</Form.Group>
						</Col>

						{/* Description */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="description" style={{ paddingBottom: "3px" }}>
									Description{" "}
									{/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
								</label>
								<input
									type="text"
									placeholder="Enter description"
									value={Description}
									// onChange={(e) => {setDescription(e.target.value)}}
									onChange={(e) =>
										handleFieldChange(setDescription, e.target.value)
									} // Track changes
								/>
							</div>
						</Col>

						{/* Issue Date */}
						<Col md={6} className="mb-2">
							<div className="w-100 post-form-group  Flatpickr-Calender-Class">
								<label htmlFor="issueDate  col-md-12">
									Issue date
									<span style={{ color: "red" }}> *</span>
								</label>
								<Flatpickr
									className="form-control Dark-Input-from-group"
									id="issueDate"
									value={IssueDate}
									// onChange={(date) => setIssueDate(date[0])}
									// onChange={(date) => handleFieldChange(setIssueDate, date[0])} // Track changes
									onChange={(date) => handleFieldChange(setIssueDate, date[0], "issueDate")} // Track changes
									placeholder="Select issue date"
									options={{
										maxDate: new Date(), // Disable future dates
										static: true, // Keeps the calendar visible on click
									}}
								/>
								{display && !IssueDate ? (
									<span className="error_msg_lbl">Select issue date </span>
								) : null}
							</div>
						</Col>

						<Col md={6} className="mb-2">
							<div className="mt-4">
								<input
									type="checkbox"
									style={{ width: "40px" }}
									checked={isChecked} // Bind the checkbox to state
									// onChange={handleCheckboxChange}
									onChange={(e) => handleFieldChange(setIsChecked, e.target.checked, "isChecked")}

								//   id={`check-${item.id}`}
								//   id={`check-${item.id}`}
								//   checked={selectedWorkLevelList.includes(item.id)}
								//   onChange={() => setPresent(true)}
								/>
								<label htmlFor="about">IsExpirable</label>
							</div>
						</Col>

						{/* Expiration Date */}
						{isChecked && (
							<Col md={6} className="mb-2">
								<div className="post-form-group col-md-6 mt-2 w-100 Flatpickr-Calender-Class">

									<label htmlFor="issueDate  col-md-12">
										Expiration date
										<span style={{ color: "red" }}> *</span>
									</label>
									<Flatpickr
										className="form-control Dark-Input-from-group"
										id="expirationDate"
										value={ExpiredDate}
										placeholder="Select expiration date"
										// onChange={(date) => setExpiredDate(date[0])}
										// onChange={(date) =>handleFieldChange(setExpiredDate, date[0])} // Track changes
										onChange={(date) => handleFieldChange(setExpiredDate, date[0], "expiredDate")} // Track changes
										options={{
											minDate: IssueDate || null, // Set minDate to startDate
											static: true, // Keeps the calendar visible on click
										}}
									/>
								</div>
							</Col>
						)}

						{/* Checkbox */}
					</Row>

					{/* Submit and Close Buttons */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
							onClick={(e) => handleSubmit(e)}
							style={{ cursor: formChanged ? "pointer" : "default" }}
						>
							<a
								href="#/"
								// onClick={(e) => handleSubmit(e)}
								className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"
									}`}
								disabled={!formChanged || isSubmitting}
								style={{
									pointerEvents: formChanged ? "auto" : "none",
									border: "none",
								}}
							>
								Submit
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default AddCertificate;
